import { curryN } from "ramda";
import { findObjPair } from "./findObjPair.mjs";
export default curryN(2, (f, x) => {
    const pair = findObjPair(f, x);
    return pair === null || pair === void 0 ? void 0 : pair[1];
});
//# sourceMappingURL=findObjVal.mjs.map